// extracted by mini-css-extract-plugin
export default {"textBox":"TextBox_textBox__9TbMC","tip":"TextBox_tip__eUUtV","warning":"TextBox_warning__xff1N","boxIcon":"TextBox_boxIcon__fNRaZ","content":"TextBox_content__lOoFn"};